<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
      @close="beforeClose"
      @submit="confirm"
    class="pushMsgDialog"
  >
    <push-msg-form
      ref="outform"
      @open-dialog="openDialog"
      @send-success="sendSuccess"
    ></push-msg-form>
  </sliderBarDialogShell>
</template>

<script>
import pushMsgForm from "@/components/wx/msg-template/pushMsgForm";

export default {
  name: "addPushMsgDialog",
  components: {
    pushMsgForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '筛选模板消息目标用户'
    }
  },
  methods: {
    openDialog(){
      this.$emit('open-dialog');
    },
    beforeClose() {
      this.$emit('close');
      this.$refs.outform && this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    sendSuccess(){
      this.$emit('send-success');
    },
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .pushMsgDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
